import React, { useState } from "react";
import DatePicker from "react-datepicker";
//import {parse, stringify} from 'flatted';
import cloneDeep from 'lodash/cloneDeep';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';

import "react-datepicker/dist/react-datepicker.css";
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import store from "../store/index";
import i18n from '../i18n';
import "./Profile.css";
import "./event.css";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';

const format = 'h:mm a';

const now = moment().hour(0).minute(0);

const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}
const min = 1;
const max = 1000;

class CreateEvent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: '',
            endDate: '',
            eventname: '',
            page:1,
            pkid: '',
            eventcreated: false,
            locations: [],
            stadiums: [],
            facilities: [],
            eventtypes: [],
            location: this.props.location.state?this.props.location.state.locationid:'',
            lang:'en',
            stadium: this.props.location.state?this.props.location.state.stadiumid:'',
            // stadium: 'SJIKZ-7815-7',
            event_type_id: '',
            //event_type_id: 'PYQZL-8133-1',
            cost: '0.000',
            title: '',
            isActive: false,
            facilitymap: [],
            tempFacility: { facility_mast_id: 0, lstAttributes: [] }
        };

        this.deleteTempFacility = this.deleteTempFacility.bind(this)

        this.addfacilityEvent = this.addfacilityEvent.bind(this)

    }

    componentDidMount() {

        if (localStorage.getItem("usertype") != "User") {

            window.scrollTo(0, 0);

            let self = this; //  declared var welcom

            this.setState({ isActive: true });
            const mosa = { ReqHead: headers }


            axios.post(API_MOSA_URL + '/User/GetLocationList', mosa)

                .then(function (response) {
                    console.log(JSON.stringify(response.data.data));
                    // self.redirectToValidate();
                    self.setState({ isActive: false });

                    if (response.status === 200) {

                        if (response.data[0].StatusCode == "0") {

                            self.setState({ locations: response.data[1] });
                            window.scrollTo(0, 0);
                            self.getEventTypes();
                            // self.venuelist();
                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: response.data[0].Message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Please try again later!',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })

                });
        } else {
            this.props.history.push('/welcome');

        }

    }
    venuelist() {
        let self = this; //  declared var welcom

        this.setState({ isActive: true });
        this.setState({ facilities: [] });
        this.setState({ cost: "0.000" });

        //this.setState({location: event.target.value});
        const mosa = { ReqHead: headers, "stadium_id": this.state.stadium, "event_type_id": this.state.event_type_id }

        axios.post(API_MOSA_URL + '/User/GetFacilityListByStadium', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {


                        self.setState({ facilities: response.data[1] });

                        // facilitymap.add({""});

                        // self.setState({ page: 2 });


                        window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    getEventTypes() {

        window.scrollTo(0, 0);

        let self = this; //  declared var welcom

        this.setState({ isActive: true });
        const mosa = { ReqHead: headers }


        axios.post(API_MOSA_URL + '/User/EventTypeGetList', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ eventtypes: response.data[1] });
                        window.scrollTo(0, 0);
                        if(self.props.location.state)
                        {
                            self.stadiumList();
                        }

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });

    }
    deleteTempFacility = (event, fid) => {
        let self = this;
        Swal.fire({
            title: "Are you sure?",
            text: "The added venue will be deleted.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.value) {
                var tempfils = this.state.facilitymap;
                for (var i = 0; i < tempfils.length; i++) {
                    if (tempfils[i].randomid === fid) {
                        tempfils.splice(i, 1); i--;
                    }
                }
                this.setState({ facilitymap: tempfils });
                this.calculateCost();
            } else {

            }
        });

    }
    addfacilityTemp = (event) => {
        if (!this.state.tempFacility.facility_mast_id) {
            Swal.fire({
                title: 'Error!',
                text: 'Please select a facility',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } else if (!this.state.title) {
            Swal.fire({
                title: 'Error!',
                text: 'Please enter Title',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        }
        else if (!this.state.participants_count) {
            Swal.fire({
                title: 'Alert',
                text: 'Please enter number of Participants!',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } else if (!this.state.tempFacility.start_date || !this.state.tempFacility.end_date) {
            Swal.fire({
                title: 'Error!',
                text: 'Please select date range',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        }
        else if (!this.state.tempFacility.start_time || !this.state.tempFacility.end_time) {
            Swal.fire({
                title: 'Error!',
                text: 'Please select Time range',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        }
        else {
            this.calculateHours();
            var tempfils = this.state.facilitymap;

            const rand = min + Math.random() * (max - min);
            this.state.tempFacility.randomid = rand;
            this.state.tempFacility.check_status = true;
            this.state.tempFacility.title = this.state.title;
            this.state.tempFacility.participants_count = this.state.participants_count;
            this.state.tempFacility.facility_id = this.state.tempFacility.facility_mast_id;

            tempfils.push(this.state.tempFacility);
            this.setState({ facilitymap: tempfils });
            this.setState({ participants_count: "" });
            this.setState({ title: "" });
            this.setState({ tempFacility: { facility_mast_id: 0, facility_id: '', lstAttributes: [], start_time: '', end_time: '' } });
        }
        this.calculateCost();


    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    stadiumList = () => {

        // alert( event.target.value);
        this.setState({ isActive: true });

        //this.setState({ location: event.target.value });
        let self = this;

        const mosa = { ReqHead: headers, "location_id": self.props.location.state.locationid }
        console.log(JSON.stringify(mosa));

        axios.post(API_MOSA_URL + '/User/GetStadiumListByLocation', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ stadiums: response.data[1] });
                        //window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }

    change = (event) => {

        // alert( event.target.value);
        this.setState({ isActive: true });

        this.setState({ location: event.target.value });
        const mosa = { ReqHead: headers, "location_id": event.target.value }
        let self = this;
        console.log(JSON.stringify(mosa));

        axios.post(API_MOSA_URL + '/User/GetStadiumListByLocation', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ stadiums: response.data[1] });
                        //window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    venue = (event) => {
        let self = this; //  declared var welcom

        this.setState({ isActive: true });
        this.setState({ facilities: [] });
        this.setState({ cost: "0.000" });


        //this.setState({location: event.target.value});
        const mosa = { ReqHead: headers, "stadium_id": this.state.stadium, "event_type_id": this.state.event_type_id }
        console.log(JSON.stringify(mosa));


        axios.post(API_MOSA_URL + '/User/GetFacilityListByStadium', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {


                        self.setState({ facilities: response.data[1] });
                        self.setState({ facilitymap: [] });

                        self.setState({ page: 2 });

                        console.log(JSON.stringify(self.state.facilities));
                        window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }
    wscalls = () => {
        this.creatEventWs();
    }

    creatEventWs = (event) => {

        event.preventDefault();
        var formattedStartDate = moment(this.state.startDate).format('MM/DD/YYYY');

        var formattedEndDate = moment(this.state.endDate).format('MM/DD/YYYY');

        const payload = {
            "event_name": this.state.eventname,
            "event_description": this.state.eventdesc,
            "stadium_id": this.state.stadium,
            "date_from": formattedStartDate,
            "date_to": formattedEndDate,
            "location_id": this.state.location,
            "event_type_id": this.state.event_type_id,

        }

        // redirectToHome();
        const mosa = { "mast": payload, ReqHead: headers }
        console.log('calling api ...' + JSON.stringify(payload));
        let self = this; //  declared var welcom



        this.setState({ isActive: true });

        axios.post(API_MOSA_URL + '/Company/CreateNewEvent', mosa)
            .then(function (response) {
                //console.log(JSON.stringify(response.data[0]));
                // self.redirectToValidate();
                self.setState({ isActive: false });
                self.setState({ pkid: response.data[0].PK_ID });

                if (response.status === 200) {
                    if (response.data[0].StatusCode == "0") {
                        self.addfacilityEvent(response.data[0].PK_ID);
                        window.scrollTo(0, 0);
                        //self.setState({ eventcreated: true });

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }


                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {

                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!!!!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });




    }
    addfacilityEvent = (evid) => {


        var formattedStartDate = moment(this.state.startDate).format('MM/DD/YYYY');

        var formattedEndDate = moment(this.state.endDate).format('MM/DD/YYYY');
        // redirectToHome();
        const nfacilities = cloneDeep(this.state.facilitymap);
        console.log('calling api 1 ...' + evid);
        console.log('calling api 2 ...' + nfacilities);
        // var nfacilities = this.state.facilities;
        const mosaa = {
            "event_id": evid, "stadium_id": this.state.stadium,
            "date_from": formattedStartDate,
            "date_to": formattedEndDate,
            "location_id": this.state.location,
            "facility_list": nfacilities, ReqHead: headers
        }
        // console.log('calling api ...' + JSON.stringify(payload));
        let self = this; //  declared var welcom
        self.setState({ eventcreated: false });

        this.setState({ isActive: true });

        console.log('calling EI api ...' + JSON.stringify(mosaa));
        // stringify(mosa);

        axios.post(API_MOSA_URL + '/Company/EventFacilityInsert', mosaa)
            .then(function (response) {
                // console.log(JSON.stringify(response));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {
                    if (response.data[0].StatusCode == "0") {
                        Swal.fire({
                            title: 'Success',
                            text: 'Your Event request is submitted',
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                //window.location.reload(false);
                                self.props.history.push('/profile');
                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!!!!!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }


                } else {
                    Swal.fire({
                        title: 'Error!**',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                // console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!--->',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });




    }
    facilityChange = (event) => {

        this.setState({ tempattribute: [] });

        for (var i = 0; i < this.state.facilities.length; i++) {
            console.log('FC SEARCH ' + event.target.value + '-' + this.state.facilities[i].facility_mast_id);

            if (this.state.facilities[i].facility_mast_id === event.target.value) {
                console.log('FC SETTING BETTER ' + this.state.facilities[i].lstAttributes.length);
                var tempCopy = cloneDeep(this.state.facilities[i]);
                this.setState({ tempFacility: tempCopy });
            }
        }
    }
    stadiumChange = (event) => {

        console.log('stad name --- ' + JSON.stringify(event.target.text));
        this.setState({ stadiumname: event.target.text });
        this.setState({ stadium: event.target.value });
    }

    evTypeChange = (event) => {


        this.setState({ event_type_id: event.target.value });
    }

    changePage = (event, pageno) => {
        if (pageno == 2) {
            if (!this.state.eventname) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please enter event name!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
            else if (!this.state.event_type_id) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please select event Type!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
            else if (!this.state.location) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please select Location!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });

            }
            else if (!this.state.stadium) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please select Stadium!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
            else if (!this.state.startDate) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please select start date!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
            else if (!this.state.endDate) {
                Swal.fire({
                    title: 'Alert',
                    text: 'Please select end date!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
            else {
                this.venue(event);
                window.scrollTo(0, 0)

            }
        }
        else if (pageno == 1) {
            this.setState({ page: pageno });
            window.scrollTo(0, 0)

        }
        else if (pageno == 3) {
            this.setState({ page: pageno });
            window.scrollTo(0, 0)

        }
    }

    calculateHours() {

        console.log("Calculating time ... " + this.state.tempFacility.start_time + "... " + this.state.tempFacility.end_time);

        let timeA = moment(this.state.tempFacility.start_time, "HH:mm");
        let timeB = moment(this.state.tempFacility.end_time, "HH:mm");

        console.log("TMIE A === " + timeA.format());
        console.log("TMIE B === " + timeB.format());

        var hours = moment
            .duration(moment(timeB, 'HH:mm')
                .diff(moment(timeA, 'HH:mm'))
            ).asHours();

        var days = moment
            .duration(moment(this.state.tempFacility.end_date, 'MM/DD/YYYY')
                .diff(moment(this.state.tempFacility.start_date, 'MM/DD/YYYY'))
            ).asDays();
        console.log("TOT DAYS === " + days);

        var tothrs = hours * (days + 1);
        console.log("TOT HOURS NOW === " + (tothrs));
        this.state.tempFacility.days = days + 1;

        if (hours > 0) {
            this.state.tempFacility.total_hour = Math.round(tothrs);
            var totcost = Math.round(tothrs * this.state.tempFacility.rate);
            this.state.tempFacility.lstAttributes.forEach((attribute, subindex) => {
                if (attribute.check_status === "true") {

                    console.log("ADDING VAL " + totcost + "..." + attribute.rate + "..." + days);
                    totcost = parseFloat(totcost) + parseFloat(attribute.rate * (days + 1));
                    console.log("FINN COST " + totcost);
                    attribute.total_rate = parseFloat(attribute.rate * (days + 1));
                    attribute.total_hour = (days + 1);
                } else {
                    console.log("NOT ADDING VAL ");

                }
            });

            this.state.tempFacility.total_rate = totcost;
        }
        else {
            this.state.tempFacility.total_hour = "";
            this.state.tempFacility.total_rate = "";

        }
        this.calculateCost();

    }
    handleFacilityTimeTemp = (time) => {
        console.log('dsd1' + time);
        this.state.tempFacility.start_time = time;
        this.calculateHours();
    }

    handleFacilityTimeEndTemp = (time) => {
        console.log('dsd' + time);
        this.state.tempFacility.end_time = time;
        this.calculateHours();

    }
    handleDateTemp = date => {

        console.log("date -- " + date);
        this.state.tempFacility.start_date = date;
        this.calculateHours();


    };
    handleEndDateTemp = date => {
        console.log('dsd' + date);

        this.state.tempFacility.end_date = date;
        this.calculateHours();


    };
    handleDate = date => {

        var formattedDate = moment(date).format('MM/DD/YYYY');
        this.setState({
            startDate: date,
            displayStartDate: formattedDate
        });
    };
    handleEndDate = date => {
        var formattedDate = moment(date).format('MM/DD/YYYY');


        this.setState({
            endDate: date,
            displayEndDate: formattedDate

        });
    };

    calculateCost = () => {

        var newcost = "0.000";
        var newfacilitycost = "0.000";
        this.state.facilitymap.forEach((facility, index) => {

            newcost = parseFloat(newcost) + parseFloat(facility.total_rate);
            newfacilitycost = parseFloat(newfacilitycost) + parseFloat(facility.total_rate);

            facility.lstAttributes.forEach((attribute, subindex) => {
                if (attribute.check_status === "true") {

                    console.log("ADDING VAL " + newcost + "..." + attribute.rate + "..." + facility.days);
                    newcost = parseFloat(newcost);
                    console.log("FINN COST " + newcost);

                } else {
                    console.log("NOT ADDING VAL " + newcost + "..." + attribute.rate + "..." + facility.days);

                }
            });

        });


        this.setState({ cost: newcost });
        this.setState({ facilitycost: newfacilitycost });


    }
    handleFacilityAttribute = (e, x, updatedfacility) => {

        this.calculateCost();


        var attributecost = e.target.value.split("_")[2];
        var facilityid = e.target.value.split("_")[1];
        var attrid = e.target.value.split("_")[0];
        var attractive = e.target.value.split("_")[3];

        var currentcost = parseFloat(this.state.cost);

        x.check_status = attractive === "true" ? "false" : "true";


        this.calculateCost();


    }

    handleFacilityAttributeTemp = (e, x, updatedfacility) => {

        // this.calculateCost();


        var attributecost = e.target.value.split("_")[2];
        var facilityid = e.target.value.split("_")[1];
        var attrid = e.target.value.split("_")[0];
        var attractive = e.target.value.split("_")[3];

        var currentcost = parseFloat(this.state.cost);

        x.check_status = attractive === "true" ? "false" : "true";
        console.log('checking adding --- ' + x.check_status + '...' + attributecost);

        this.calculateHours();


    }

    handleFacilityDate = (date, updatedfacility) => {
        console.log('dsd1' + date);
        updatedfacility.start_date = date;
        this.calculateCost();
    }

    handleFacilityDateEnd = (date, updatedfacility) => {
        console.log('dsd' + date);
        updatedfacility.end_date = date;
        this.calculateCost();
    }

    handleFacilityTime = (time, updatedfacility) => {
        console.log('dsd1' + time);
        updatedfacility.start_time = time;
        this.calculateCost();
    }

    handleFacilityTimeEnd = (time, updatedfacility) => {
        console.log('dsd' + time);
        updatedfacility.end_time = time;
        this.calculateCost();
    }



    handleFacility = (e, updatedfacility) => {
        var formattedStartDate = moment(this.state.startDate).format('MM/DD/YYYY');

        var formattedEndDate = moment(this.state.endDate).format('MM/DD/YYYY');

        var newcost = parseFloat(this.state.cost);

        var facilityid = e.target.value.split("_")[2];
        var facilityactive = e.target.value.split("_")[1];
        // updatedfacility.start_date = formattedStartDate;
        // updatedfacility.end_date = formattedEndDate;
        // updatedfacility.start_time = "12:20 AM";
        // updatedfacility.end_time = "12:20 PM";
        updatedfacility.check_status = facilityactive === "true" ? "false" : "true";


        this.calculateCost();
    }
    render() {
        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });

        let locations = this.state.locations;
        let optionItems = locations.map((location) =>
            <option value={location.location_mast_id}>{location.location_name_en}</option>
        );

        let stadiums = this.state.stadiums;
        let stadItems = stadiums.map((stadium) =>
            <option value={stadium.stadium_mast_id}>{stadium.stadium_name_en}</option>
        );

        let evtypes = this.state.eventtypes;
        let evItems = evtypes.map((evtype) =>
            <option value={evtype.event_type_mast_id}>{evtype.event_type_name_en}</option>
        );

        let fcs = this.state.facilities;
        let fcts = fcs.map((fc) =>
            <option value={fc.facility_mast_id}>{fc.facility_name_en}</option>
        );

        let commentNodesNew = this.state.facilitymap.map(function (facility, index) {
            var formattedStartDate = moment(facility.start_date).format('MM/DD/YYYY');

            var formattedEndDate = moment(facility.end_date).format('MM/DD/YYYY');
            return <tr key={index} >
                <td>{facility.facility_name_en}</td>
                <td>{formattedStartDate}</td>
                <td>{formattedEndDate}</td>
                <td>OMR {facility.total_rate}</td>
                <td className="text-center"><button onClick={e => self.deleteTempFacility(e, facility.randomid)} className="btn btn-danger tooltips" >
                    <span className="fa fa-minus-square"></span>
                </button></td>
            </tr>
        });

        let eventsummaryNodes = this.state.facilitymap.map(function (facility, index) {
            var formattedStartDate = moment(facility.start_date).format('MM/DD/YYYY');

            var formattedEndDate = moment(facility.end_date).format('MM/DD/YYYY');
            return <tr key={index} >
                <td>{index + 1}</td>
                <td><strong>{facility.facility_name_en}</strong>
                    <br />from: {formattedStartDate} to : {formattedEndDate}</td>
                <td className="text-center"> {facility.total_hour}</td>
                <td className="text-center">OMR {facility.rate}</td>
                <td className="text-right">OMR {facility.total_rate}</td>
            </tr>

        });

        let commentNodes = this.state.facilitymap.map(function (facility, index) {
            return <div key={index} className="border-bottom">
                <div className="border">
                    <div className="card card-custom">
                        <div className="card-header card-header-right ribbon ribbon-clip ribbon-left">
                            <div className="row">
                                <div className="col-md-10">
                                    <div className="text-left" style={{ top: '12px' }}>
                                        <span className="text-muted" />OMR {facility.rate}</div>
                                    <h3 className="card-title text-left">{facility.facility_name_en}</h3>

                                </div>
                                <div className="col-md-2">
                                    <button onClick={e => self.deleteTempFacility(e, facility.randomid)} className="btn btn-danger tooltips" >
                                        <span className="fa fa-minus-square"></span>
                                    </button>
                                </div>
                            </div>
                        </div>




                        <div className="card-body">
                            <div className=" row text-left" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                                <label className="col-md-2 col-form-label form-control-label text-muted" style={{ fontSize: '10px' }}> Start Date</label>
                                <div className="col-md-4">
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        value={facility.start_date}
                                        minDate={moment().toDate()}
                                        selected={facility.start_date}
                                        onChange={date => { self.handleFacilityDate(date, facility) }}

                                    />
                                </div>
                                <label className="col-md-2 col-form-label form-control-label text-left text-muted" style={{ fontSize: '10px' }}>End Date</label>
                                <div className="col-md-4">
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        value={facility.end_date}
                                        minDate={moment().toDate()}
                                        selected={facility.end_date}
                                        onChange={date => { self.handleFacilityDateEnd(date, facility) }}

                                    />
                                </div>
                            </div>
                            <br />
                            <div className=" row text-left" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                                <label className="col-md-2 col-form-label form-control-label text-muted" style={{ fontSize: '10px' }}> Start Time</label>
                                <div className="col-md-4">

                                    <input type="time"
                                        className="form-control"
                                        placeholder="End Time"
                                        onChange={date => { self.handleFacilityTime(date, facility) }}
                                        value={facility.start_time}
                                    />
                                </div>
                                <label className="col-md-2 col-form-label form-control-label text-left text-muted" style={{ fontSize: '10px' }}>End Time</label>
                                <div className="col-md-4">

                                    <input type="time"
                                        className="form-control"
                                        placeholder="End Time"
                                        onChange={(ev) => { this.handleFacilityTimeEnd(ev.target.value) }}
                                        value={facility.end_time}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className=" row text-left" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                                <span class="label label-primary">Rate OMR {facility.rate} per hour</span>

                            </div>
                            <div className="row" style={{ paddingRight: '15px', paddingLeft: '15px' }}>


                                {facility.lstAttributes.map(x =>
                                    <div className="d-flex align-items-center border">

                                        <label className="checkbox checkbox-lg checkbox-light-success checkbox-inline flex-shrink-0 m-0 mx-4">
                                            <input
                                                type="checkbox"
                                                value={x.facility_attribute_mast_id + "_" + x.facility_id + "_" + x.rate + "_" + x.check_status}
                                                checked={x.check_status === "true" ? true : false}
                                                onChange={(e) => {
                                                    self.handleFacilityAttribute(e, x, facility);
                                                }} />
                                            <span />
                                        </label>

                                        <div className="d-flex flex-column flex-grow-1" style={{ padding: '5px' }}>
                                            <a href="#" className="text-dark-75 text-hover-primary font-weight-bold font-size-lg mb-1">{x.attribute_name_en}</a>
                                            <span className="text-muted font-weight-bold">Extra charges OMR : {x.rate}</span>
                                        </div>

                                        <span style={{ margin: '5px' }} className="bullet bullet-bar bg-success align-self-stretch" />


                                    </div>
                                )}
                            </div>
                        </div>




                    </div>

                </div>
            </div>;
        });
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: 'lightgrey'  }}>


                    <Navbar page={6} />
                    <div className="all-title-box">
                        <div className="container text-center spectitle">
                            <h1  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK26', this.state.lang)}<span className="m_1">{i18n.t('JK52', this.state.lang)}</span></h1>
                        </div>
                    </div>
                    <div className="">
                        <div className="container py-3">
                            <div className="row card" style={{ maxWidth: '900px', margin: 'auto' }}>
                                <div className="" style={{ width: '100%' }}>


                                    {this.state.page == 1 &&
                                        <div className="" >
                                            {/* <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                                        <div className=" ">
                                                            <div className="">
                                                                <img src="https://cdn3.iconfinder.com/data/icons/winners-medal-icon-set/844/Germany-512.png" style={{ width: '30%' }} />

                                                                <h2 className="py-3">Create a Sports Event</h2>
                                                                <p>Create a sports event in 3 simple steps
                                                                </p>
                                                                <a className="btn btn-primary" style={{ width: '250px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 1 - Add Event Details</span></a>
                                                                <a className="btn btn-info" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey' }}>Step 2 - Add  facility for the event</span></a>
                                                                <a className="btn btn-info" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 3 - Make Payment</span></a>

                                                            </div>
                                                        </div>
                                                    </div> */}
                                            <div className="border tab">

                                                <div className="">
                                                    <nav>
                                                        <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                                            <a className="nav-item nav-link border-right" id="nav-home-tab" style={{ backgroundColor: '#ed1f24' }} ><span style={{ color: 'white',fontFamily: 'Tajawal' }}>{i18n.t('JK53', this.state.lang)}</span></a>
                                                            <a className="nav-item nav-link border-right" id="nav-contact-tab" style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal' }}>{i18n.t('JK54', this.state.lang)}</a>
                                                            <a className="nav-item nav-link" id="nav-about-tab" style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal' }}>{i18n.t('JK55', this.state.lang)}</a>
                                                        </div>
                                                    </nav>
                                                    <div className="container">


                                                        <br />

                                                        < div className="form-group row fv-plugins-icon-container text-left">
                                                            <label className="col-xl-3 col-lg-3 col-form-label text-muted"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK40', this.state.lang)}</label>
                                                            <div className="col-lg-9 col-xl-9">
                                                                <input className="form-control" value={this.state.eventname} name="eventname" onChange={this.myChangeHandler} type="text" placeholder={i18n.t('JK40', this.state.lang)} />
                                                                <div className="fv-plugins-message-container" /></div>
                                                        </div>

                                                        <div className="form-group row text-left">
                                                            <label className="col-lg-3 col-form-label form-control-label text-muted"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK176', this.state.lang)}</label>
                                                            <div className="col-lg-9 text-center">
                                                                <select style={{ width: '100%' }} value={this.state.event_type_id} onChange={this.evTypeChange} className="form-control" id="dropdown">
                                                                    <option value="N/A">{i18n.t('JK56', this.state.lang)}</option>
                                                                    {evItems}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row fv-plugins-icon-container text-left">
                                                            <label className="col-xl-3 col-lg-3 col-form-label text-muted"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK41', this.state.lang)}</label>
                                                            <div className="col-lg-9  col-xl-9">
                                                                <textarea className="form-control" value={this.state.eventdesc} name="eventdesc" onChange={this.myChangeHandler} rows="4"
                                                                    placeholder={i18n.t('JK57', this.state.lang)} />
                                                            </div>
                                                        </div>

                                                        {/* < div className="form-group row fv-plugins-icon-container text-left">
                                                                    
                                                                </div> */}


                                                        < div className="form-group row fv-plugins-icon-container text-left">
                                                            <label className="col-xl-3 col-lg-3 col-form-label text-muted"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK58', this.state.lang)}</label>
                                                            <div className="col-lg-9 col-xl-9">
                                                                <select className="form-control" style={{ width: '100%' }} onChange={this.change} value={this.state.location}>
                                                                    <option>{i18n.t('JK58', this.state.lang)}</option>
                                                                    {optionItems}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        < div className="form-group row fv-plugins-icon-container text-left">
                                                            <label className="col-xl-3 col-lg-3 col-form-label text-muted">{i18n.t('JK59', this.state.lang)}</label>
                                                            <div className="col-lg-9 col-xl-9">
                                                                <select className="form-control" style={{ width: '100%' }} id="exampleFormControlSelect1" onChange={this.stadiumChange} value={this.state.stadium}>
                                                                    <option>{i18n.t('JK59', this.state.lang)}</option>
                                                                    {stadItems}
                                                                </select>
                                                            </div>
                                                        </div>




                                                        <div className="form-group row text-left">
                                                            <label className="col-lg-3 col-form-label form-control-label text-muted">
                                                            {i18n.t('JK43', this.state.lang)}</label>
                                                            <div className="col-lg-3">
                                                                <DatePicker
                                                                    id="kt_datepicker_1"
                                                                    className="form-control"
                                                                    value={this.state.startDate}
                                                                    minDate={moment().toDate()}
                                                                    selected={this.state.startDate}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onChange={this.handleDate}
                                                                />
                                                            </div>
                                                            <label className="col-lg-3 col-form-label form-control-label text-left text-muted">{i18n.t('JK44', this.state.lang)}</label>
                                                            <div className="col-lg-3">
                                                                <DatePicker
                                                                    className="form-control"
                                                                    dateFormat="dd/MM/yyyy"
                                                                    value={this.state.endDate}
                                                                    minDate={moment().toDate()}
                                                                    selected={this.state.endDate}
                                                                    onChange={this.handleEndDate}
                                                                />
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div className="card-footer">
                                                            <div className="row">
                                                                <div className="col-lg-9"></div>
                                                                <div className="col-lg-3">
                                                                    <button className="btn btn-light btn-radius btn-brd grd1" style={{ width: '100%' }} onClick={e => this.changePage(e, 2)}>{i18n.t('DS6', this.state.lang)}</button>

                                                                </div>
                                                            </div>
                                                        </div>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.page == 2 &&
                                        <div className="">
                                            {/* <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                                        <div className=" ">
                                                            <div className="">
                                                                <img src="https://cdn3.iconfinder.com/data/icons/winners-medal-icon-set/844/Germany-512.png" style={{ width: '30%' }} />

                                                                <h2 className="py-3">Create a Sports Event</h2>
                                                                <p>Create a sports event in 3 simple steps
                                                         </p>
                                                                <a className="btn btn-info" style={{ width: '250px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 1 - Add Event Details</span></a>
                                                                <a className="btn btn-primary" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey' }}>Step 2 - Add  facility for the event</span></a>
                                                                <a className="btn btn-info" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 3 - Make Payment</span></a>

                                                            </div>
                                                        </div>
                                                    </div> */}
                                            <div className="border" style={{}}>
                                                <div className="">
                                                    <div className="">
                                                        <nav>
                                                            <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                                                <a className="nav-item nav-link border-right" id="nav-home-tab" style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal'}}>{i18n.t('JK53', this.state.lang)}</a>
                                                                <a className="nav-item nav-link border-right" id="nav-contact-tab" style={{ backgroundColor: '#ed1f24',fontFamily: 'Tajawal' }}  ><span style={{ color: 'white' }}>{i18n.t('JK54', this.state.lang)}</span></a>
                                                                <a className="nav-item nav-link" id="nav-about-tab"  style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal'}}>{i18n.t('JK55', this.state.lang)}</a>
                                                            </div>
                                                        </nav>
                                                        <div className="container">

                                                            <br />
                                                            <div className="hover-btn-new  log orange">
                                                                < div className="row fv-plugins-icon-container text-left">

                                                                    <div className="col-lg-6 col-xl-6">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK60', this.state.lang)}</label>

                                                                        <select value={this.state.tempFacility.facility_mast_id} id="changeFacilityOption" className="form-control" style={{ width: '100%' }} onChange={this.facilityChange}>
                                                                            <option value={0}>{i18n.t('JK60', this.state.lang)}</option>
                                                                            {fcts}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-lg-6 col-xl-6">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK61', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <input className="form-control" value={this.state.title} name="title" onChange={this.myChangeHandler} type="text" placeholder={i18n.t('JK61', this.state.lang)} />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <input className="form-control" disabled placeholder={i18n.t('JK61', this.state.lang)} />
                                                                        }
                                                                    </div>



                                                                </div>
                                                                <div className="row text-left">
                                                                    <div className="col-lg-3">
                                                                    <label className="text-left text-muted simplelabel">{i18n.t('JK43', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <DatePicker
                                                                                id="kt_datepicker_1"
                                                                                className="form-control"
                                                                                value={this.state.tempFacility.start_date}
                                                                                minDate={moment().toDate()}
                                                                                selected={this.state.tempFacility.start_date}
                                                                                dateFormat="dd/MM/yyyy"
                                                                                onChange={this.handleDateTemp}
                                                                            />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <DatePicker
                                                                                id="kt_datepicker_1"
                                                                                className="form-control"
                                                                                disabled
                                                                            />
                                                                        }

                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                    <label className="text-left text-muted simplelabel">{i18n.t('JK44', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <DatePicker
                                                                                className="form-control"
                                                                                dateFormat="dd/MM/yyyy"
                                                                                value={this.state.tempFacility.end_date}
                                                                                minDate={moment().toDate()}
                                                                                selected={this.state.tempFacility.end_date}
                                                                                onChange={this.handleEndDateTemp}
                                                                            />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <DatePicker
                                                                                className="form-control"
                                                                                dateFormat="dd/MM/yyyy"
                                                                                disabled
                                                                                placeholder="End date"
                                                                            />
                                                                        }

                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                        <label className="text-left text-muted simplelabel">{i18n.t('JK62', this.state.lang)}</label>

                                                                        {this.state.tempFacility.facility_mast_id &&

                                                                            <input type="time"
                                                                                className="form-control"
                                                                                onChange={(ev) => this.handleFacilityTimeTemp(ev.target.value)}
                                                                                value={this.state.tempFacility.start_time}
                                                                            />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <input type="time"
                                                                                className="form-control"
                                                                                disabled
                                                                            />
                                                                        }



                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                        <label className=" simplelabel text-left text-muted">{i18n.t('JK63', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <input type="time"
                                                                                className="form-control"
                                                                                placeholder={i18n.t('JK63', this.state.lang)}
                                                                                onChange={(ev) => { this.handleFacilityTimeEndTemp(ev.target.value) }}
                                                                                value={this.state.tempFacility.end_time}
                                                                            />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <input type="time"
                                                                                className="form-control"
                                                                                placeholder={i18n.t('JK63', this.state.lang)}
                                                                                disabled />
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="row text-left">
                                                                    {/* <div className="col-lg-3">
                                                                                <label className="col-form-label text-muted">Num. of participants</label>
                                                                                {this.state.tempFacility.facility_mast_id &&

                                                                                    <input className="form-control" value={this.state.participants_count} name="participants_count" onChange={this.myChangeHandler} type="number" placeholder="No. of Participants" />
                                                                                }
                                                                                {!this.state.tempFacility.facility_mast_id &&
                                                                                    <input class="form-control" disabled />
                                                                                }
                                                                            </div> */}
                                                                    <div className="col-lg-3">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK64', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <input className="form-control" value={this.state.participants_count} name="participants_count" onChange={this.myChangeHandler} type="number" placeholder="" />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <input class="form-control" disabled />
                                                                        }

                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK65', this.state.lang)}</label>
                                                                        {this.state.tempFacility.facility_mast_id &&
                                                                            <input class="form-control" disabled value={"OMR " + this.state.tempFacility.rate} />
                                                                        }
                                                                        {!this.state.tempFacility.facility_mast_id &&
                                                                            <input class="form-control" disabled />
                                                                        }

                                                                    </div>
                                                                    <div className="col-lg-3 col-xl-3">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK46', this.state.lang)}</label>
                                                                        {this.state.tempFacility.total_hour &&
                                                                            <input class="form-control" disabled value={this.state.tempFacility.total_hour} />
                                                                        }
                                                                        {!this.state.tempFacility.total_hour &&
                                                                            <input class="form-control" disabled />
                                                                        }
                                                                    </div>

                                                                    <div className="col-lg-3 col-xl-3">
                                                                        <label className="col-form-label text-muted">{i18n.t('JK66', this.state.lang)}</label>
                                                                        {this.state.tempFacility.total_rate &&
                                                                            <input class="form-control" disabled value={"OMR " + this.state.tempFacility.total_rate} />
                                                                        }
                                                                        {!this.state.tempFacility.total_rate &&
                                                                            <input class="form-control" disabled />
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {this.state.tempFacility.lstAttributes &&
                                                                    < div className="row  text-left " style={{ paddingLeft: '10px', paddingTop: '5px' }}>

                                                                        {this.state.tempFacility.lstAttributes.map(x =>
                                                                            <label className="" style={{ padding: '1px' }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    value={x.facility_attribute_mast_id + "_" + x.facility_id + "_" + x.rate + "_" + x.check_status}
                                                                                    checked={x.check_status === "true" ? true : false}
                                                                                    onChange={(e) => {
                                                                                        self.handleFacilityAttributeTemp(e, x, this.state.tempFacility);
                                                                                    }} />
                                                                                <span style={{ color: 'black', padding: '5px', textTransform: 'capitalize' }}>{x.attribute_name_en} <span className="text-muted">(OMR : {x.rate} per day)</span></span>
                                                                            </label>


                                                                        )}


                                                                    </div>
                                                                }
                                                                < div className=" row  text-left" style={{ padding: '5px' }}>
                                                                    <div className="col-lg-3 col-xl-3">

                                                                    </div>
                                                                    <div className="col-lg-3 col-xl-3">

                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <button className="btn btn-light btn-radius btn-brd grd1" onClick={e => this.addfacilityTemp(e)}><span className="fa fa-plus" />{i18n.t('JK67', this.state.lang)}</button>
                                                                    </div>
                                                                </ div>

                                                            </div>
                                                        </div>
                                                        <div className="container">
                                                            <div className="form-group row">
                                                                <div className="col-md-12" style={{ minHeight: '250px' }}>

                                                                    <div>
                                                                        {this.state.facilitymap.length != 0 &&
                                                                            <table className="table table-striped custab">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>{i18n.t('JK45', this.state.lang)}</th>
                                                                                        <th>{i18n.t('JK43', this.state.lang)}</th>
                                                                                        <th>{i18n.t('JK44', this.state.lang)}</th>
                                                                                        <th>{i18n.t('JK66', this.state.lang)}</th>
                                                                                        <th className="text-center"></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {commentNodesNew}
                                                                                </tbody></table>
                                                                        }
                                                                        {this.state.facilitymap.length == 0 &&
                                                                            <div className="alert-message alert-message-warning">
                                                                                <h4>
                                                                                    No Facilities selected</h4>
                                                                                <p>
                                                                                    Please select Location and Stadium to search available facilities</p>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group row">
                                                                <div className="col-md-9">
                                                                    <h4 className="text-left text-muted">{i18n.t('JK70', this.state.lang)}</h4>
                                                                </div>
                                                                <div className="col-md-3 text-center">
                                                                    <span style={{ color: "orange", fontSize: '20px' }}>OMR {this.state.cost}</span>
                                                                </div>
                                                            </div>

                                                            <hr />
                                                            <div className="form-group row">
                                                                <div className="col-lg-3">
                                                                    <button className="btn btn-light btn-radius btn-brd grd1" onClick={e => this.changePage(e, 1)}>{i18n.t('JK18', this.state.lang)}</button>
                                                                </div>
                                                                <div className="col-lg-3"></div>

                                                                <div className="col-lg-3"></div>
                                                                <div className="col-lg-3 text-right">
                                                                    <button className="btn btn-light btn-radius btn-brd grd1" onClick={e => this.changePage(e, 3)}>{i18n.t('JK19', this.state.lang)}</button>
                                                                </div>
                                                            </div>
                                                        </div>



                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    }
                                    {this.state.page == 3 &&
                                        <div className="">
                                            {/* <div className="col-md-4 py-5  text-white text-center " style={{ backgroundColor: '#4c5a7d ' }}>
                                                            <div className=" ">
                                                                <div className="">
                                                                    <img src="https://cdn3.iconfinder.com/data/icons/winners-medal-icon-set/844/Germany-512.png" style={{ width: '30%' }} />
    
                                                                    <h2 className="py-3">Create a Sports Event</h2>
                                                                    <p>Create a sports event in 3 simple steps
                                                             </p>
                                                                    <a className="btn btn-info" style={{ width: '250px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 1 - Add Event Details</span></a>
                                                                    <a className="btn btn-primary" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey' }}>Step 2 - Add  facility for the event</span></a>
                                                                    <a className="btn btn-info" style={{ width: '250px', marginTop: '2px' }}><span style={{ color: 'lightgrey', width: '250px' }}>Step 3 - Make Payment</span></a>
    
                                                                </div>
                                                            </div>
                                                        </div> */}
                                            <div className="border" style={{}}>
                                                <div className="">
                                                    <div className="">
                                                        <nav>
                                                            <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                                                <a className="nav-item nav-link border-right" id="nav-home-tab" style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal'}}>{i18n.t('JK53', this.state.lang)}</a>
                                                                <a className="nav-item nav-link border-right" id="nav-contact-tab" style={{ backgroundColor: '#ff7675',fontFamily: 'Tajawal'}}>{i18n.t('JK54', this.state.lang)}</a>
                                                                <a className="nav-item nav-link" id="nav-about-tab"  style={{ backgroundColor: '#ed1f24',fontFamily: 'Tajawal' }}  ><span style={{ color: 'white' }}>{i18n.t('JK55', this.state.lang)}</span></a>
                                                            </div>
                                                        </nav>
                                                        <div className="container">
                                                            <div className="grid invoice">
                                                                <div className="grid-body">
                                                                    <div className="invoice-title">
                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                <h3>{i18n.t('JK177', this.state.lang)}</h3>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div className="stats">
                                                                            <div>
                                                                                <strong>{i18n.t('JK40', this.state.lang)}</strong> {this.state.eventname}
                                                                            </div>
                                                                            <div>
                                                                                <strong>{i18n.t('JK43', this.state.lang)}</strong> {this.state.displayStartDate}
                                                                            </div>
                                                                            <div>
                                                                                <strong>{i18n.t('JK44', this.state.lang)}</strong> {this.state.displayEndDate}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <h3>{i18n.t('JK178', this.state.lang)}</h3>
                                                                            <table className="table table-striped">
                                                                                <thead>
                                                                                    <tr className="line">
                                                                                        <td><strong>#</strong></td>
                                                                                        <td className="text-center"><strong>{i18n.t('JK179', this.state.lang)}</strong></td>
                                                                                        <td className="text-center"><strong>{i18n.t('JK46', this.state.lang)}</strong></td>
                                                                                        <td className="text-right"><strong>{i18n.t('JK47', this.state.lang)}</strong></td>
                                                                                        <td className="text-right"><strong>{i18n.t('JK176', this.state.lang)}</strong></td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {eventsummaryNodes}
                                                                                    <tr>
                                                                                        <td colSpan={3} />
                                                                                        <td className="text-right"><strong>{i18n.t('JK176', this.state.lang)}</strong></td>
                                                                                        <td className="text-right"><strong>N/A</strong></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td colSpan={3}>
                                                                                        </td><td className="text-right"><strong>{i18n.t('JK70', this.state.lang)}</strong></td>
                                                                                        <td className="text-right"><strong>OMR {this.state.cost}</strong></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className="form-group row">
                                                                        <div className="col-lg-3">
                                                                            <button className="btn btn-light btn-radius btn-brd grd1" onClick={e => this.setState({ page: 2 })}>{i18n.t('JK18', this.state.lang)}</button>
                                                                        </div>
                                                                        <div className="col-lg-3"></div>

                                                                        <div className="col-lg-3"></div>
                                                                        <div className="col-lg-3 text-right">
                                                                            <button className="btn btn-light btn-radius btn-brd grd1" onClick={this.creatEventWs}>{i18n.t('JK26', this.state.lang)}</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </LoadingOverlay >
        )
    }
}
export default withRouter(CreateEvent);
